module.exports = __webpack_public_path__ + "img/147.6cfc86e3.jpg";